import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { useAuth } from '../../../auth';
import { getMonitoring, getMonitoringtenant } from '../request/request';
import { ViewGrafica } from '../Modal/ModalGraficas';
import { ViewGraficaPerformance } from '../Modal/ModalPerformance';
import { Link } from 'react-router-dom';

type monitoring = {

  displayName: string,
  status: any,
  SysUptime: string,
  StatusLicence: string,
  onlineLicence: string,
  connectedLicence: string,
  pingms: number,
  pingstatus: number,
  pingloss: number,
  diskAvailable: number,
  dskTotal: number,
  dskUsed: number,
  CPUload1m: number,
  CPUload1mlast10: [
    {
      clock: string,
      value: string
    }
  ]
  ramAvailable: string
  ramTotal: string
  ramUsed: string
  ping: [
    { ip: string, avg: string, source: string }]

  histping: [
    {
      timestamp: any,
      ping: [{ ip: string, avg: string, source: string }]
    }
  ]
}

type ID = undefined | null | number

function LatencyTablePerfor(props: any) {
  const [ID, setID] = useState<ID>(undefined)
  const [IDPer, setIDPer] = useState<ID>(undefined)


  const [chartId, setchartId] = useState<any>()
  const [chartIdper, setchartIdper] = useState<any>()


  const [Category, setCategory] = useState<any>()
  const [Categoryper, setCategoryper] = useState<any>()

  const [datalatency, setdatalatenci] = useState<any>()
  const [dataperformance, setdataperformance] = useState<any>()

  const [Namectx, setNamectx] = useState<any>()
  const [Namectxper, setNamectxper] = useState<any>()

  const { currentUser } = useAuth()
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type) || "CloudGlobal";
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const FlagReg = useAppSelector(state => state.FlagSlice.value)

  /**********************Llamada a axios y parse de data**********************/
  /*********************se hacen cambios para poc filtroi por aws y azr*********************/

  const [datamonitoring, setdata] = useState<monitoring[]>([])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id !== 0 && Type !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(Id, Type, nameregion);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getMonitoringtenant(Id, tenant, Type, nameregion);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }
        else if (Id !== 0 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(Id);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else {
            const available = await getMonitoringtenant(Id, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }
      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [Id, nameregion, props.tab])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (Id === -1 && Type === 'CloudGlobal' && currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
          if (tenant === 0) {
            const datos = await getMonitoring(-1);
            if (datos.data && datos.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(datos.data);
            }
          }
          else if (tenant !== 0) {
            const available = await getMonitoringtenant(-1, tenant);
            if (available.data && available.data.error === 'id suscription invalido') {
              setdata([])
            } else {
              setdata(available.data);
            }

          }
        }

      } catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
    };

    fetchData();
  }, [tenant, Id, props.tab, Type])

  //////////////////////////////////////




  // Map sobre datamonitoring para obtener arrays de CPUload1mlast10 de cada elemento
  const categoryesPing = datamonitoring.map((item) =>
    item.histping?.map((innerItem) => {
      const date = new Date(Number(innerItem.timestamp) * 1000);
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // Formatea como desees, este es solo un ejemplo
      const formattedDate = `${day}/${date.getMonth() + 1} ${hours}:${minutes}`;

      return formattedDate;
    }).reverse() || []
  );



  const dataArraysPing = datamonitoring.map((item) =>
    item.histping?.map((innerItem) =>
      innerItem.ping.map((pingItem) => Number(pingItem.avg))
    ).reverse() || []

  );

  /************array de series************ */
  const seriesData = datamonitoring.map((item, index) => ({
    type: 'line',
    name: 'AVG-' + item.displayName,
    data: dataArraysPing[index].reverse()
  }));

  // Encuentra el primer histping con datos y extrae su categoría
  const firstHistPingWithData = datamonitoring.find(item => item.histping.length > 0);
  const firstHistPingCategory = firstHistPingWithData ? firstHistPingWithData.histping.map(innerItem => {
    const date = new Date(Number(innerItem.timestamp) * 1000);
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Formatea como desees, este es solo un ejemplo
    return `${day}/${date.getMonth() + 1} ${hours}:${minutes}`;
  }).reverse() : [];



  /**************************************************************************************************************/
  //////////////////////////////////////

  // Map sobre datamonitoring para obtener arrays de CPUload1mlast10 de cada elemento
  const categoriesArrays = datamonitoring.map((item) =>
    item.CPUload1mlast10?.map((innerItem) => {
      const date = new Date(Number(innerItem.clock) * 1000);
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();

      // Formatea como desees, este es solo un ejemplo
      const formattedDate = `${day}/${date.getMonth() + 1} ${hours}:${minutes}`;

      return formattedDate;
    }).reverse() || []
  );

  const dataArrays = datamonitoring.map((item) =>
    item.CPUload1mlast10?.map((innerItem) => Number(innerItem.value)).reverse() || []
  );

  /************array de series************ */
  const seriesDataperformance = datamonitoring.map((item, index) => ({
    type: 'line',
    name: 'AVG-' + item.displayName,
    data: dataArrays[index].reverse()
  }));

  // Encuentra el primer histping con datos y extrae su categoría
  const firstHistCPUWithData = datamonitoring.find(item => item.CPUload1mlast10 !== null && item.CPUload1mlast10?.length > 0);
  const firstHistCPU = firstHistCPUWithData ? firstHistCPUWithData.CPUload1mlast10.map(innerItem => {
    const date = new Date(Number(innerItem.clock) * 1000);
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Formatea como desees, este es solo un ejemplo
    return `${day}/${date.getMonth() + 1} ${hours}:${minutes}`;
  }).reverse() : [];

  return (
    <>
      <div className='card'>
        {/* begin::Header */}
        {Type && <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Latency</span>
          </h3>
          <button onClick={() => (setID(1), setchartId('all'), setCategory(firstHistPingCategory), setdatalatenci(seriesData), setNamectx('All CTX Latency'))} className='btn-light-marino f-parrafo'> Latency Historic</button>

        </div>}

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>

                {/* begin::Table */}
                <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                  {/* begin::Table head */}
                  {Type !== 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Ping/ms</th>
                      <th className='table-cell'>Packet Loss</th>
                      <th className='table-cell'>Ping to Internet</th>
                      <th className='table-cell'>Status</th>
                      <th className='table-cell'>Historic</th>

                    </tr>
                  </thead>}
                  {Type === 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Ping/ms</th>
                      <th className='table-cell'>Packet Loss</th>
                      <th className='table-cell'>Ping to Internet</th>
                      <th className='table-cell'>Status</th>
                      <th className='table-cell'>Historic</th>

                    </tr>
                  </thead>}
                  {/* end::Table head */}


                  {/* begin::Table body */}
                  {Type !== 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) =>
                          d.displayName.includes(Type) && (
                            <tr key={i} className='table-row'>
                              <td className='table-cell'>{d.displayName}</td>
                              <td className='table-cell'>{d.pingms.toFixed(3)}</td>
                              <td className='table-cell'>{d.pingloss}</td>
                              {d.ping !== null && d.ping.length !== 0 ? (
                                d.ping.map((data: any, i: any) => (
                                  <td key={i} className='table-cell'>{data.avg}</td>
                                ))
                              ) : (
                                <td className='table-cell'>---</td>
                              )}
                              {d.pingstatus === 1 ? (
                                <td className='table-cell'>
                                  <p>Up</p>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-arrow-up-circle" viewBox="0 0 16 16">
                                    <path
                                      fillRule="evenodd"
                                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" fill="#00BCD1"
                                    />
                                  </svg>
                                </td>
                              ) : d.pingstatus === 0 ? (
                                <td className='table-cell'>
                                  <p>Down</p>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                    <path
                                      fillRule="evenodd"
                                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" fill="#FF4089"
                                    />
                                  </svg>
                                </td>
                              ) : (
                                '---'
                              )}
                              <td className='table-cell'>
                                <button
                                  className="btn-relieve f-parrafo"
                                  onClick={() => (setID(null), setchartId(i), setCategory(categoryesPing[i]), setdatalatenci(dataArraysPing[i]), setNamectx(d.displayName))}
                                >
                                  <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '20px' }} />
                                </button>
                              </td>
                              <td></td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  )}

                  {Type === 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) => (
                          <tr key={i} className='table-row'>
                            <td className='table-cell'>{d.displayName}</td>
                            <td className='table-cell'>{d.pingms.toFixed(3)}</td>
                            <td className='table-cell'>{d.pingloss}</td>
                            {d.ping !== null && d.ping.length !== 0 ? (
                              d.ping.map((data: any, i: any) => (
                                <td key={i} className='table-cell'>{data.avg}</td>
                              ))
                            ) : (
                              <td className='table-cell'>---</td>
                            )}
                            {d.pingstatus === 1 ? (
                              <td className='table-cell'>
                                <p>Up</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-arrow-up-circle" viewBox="0 0 16 16">
                                  <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" fill="#00BCD1" />
                                </svg>
                              </td>
                            ) : d.pingstatus === 0 ? (
                              <td className='table-cell'>
                                <p>Down</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                                  <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" fill="#FF4089" />
                                </svg>
                              </td>
                            ) : (
                              '---'
                            )}
                            <td className='table-cell'>
                              <button
                                className="btn-relieve f-parrafo"
                                onClick={() => (setID(null), setchartId(i), setCategory(categoryesPing[i]), setdatalatenci(dataArraysPing[i]), setNamectx(d.displayName))}
                              >
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '20px' }} />
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}

                  {/* end::Table body */}

                </table>
                {/* end::Table */}

              </div>


            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        <br />
        {/* end::Body */}
      </div>

      {ID !== undefined && <ViewGrafica setID={setID} id={ID} chartId={chartId} categorye={Category} data={datalatency} name={Namectx} />}

      <div className='card'>
        {Type !== 'Global' && <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md'>Performance</span>
          </h3>
          <button onClick={() => (setIDPer(1), setchartIdper('all'), setCategoryper(firstHistCPU), setdataperformance(seriesDataperformance), setNamectxper('All CTX CPU Usage'))} className='btn-light-marino f-parrafo'> CPU Usage Historic</button>

        </div>}

        {/* begin::Body */}
        <div className='card-body py-3'>
          <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
              {/* begin::Table container */}
              <div className='table-responsive'>

                {/* begin::Table */}
                <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                  {/* begin::Table head */}
                  {Type !== 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Available Disk</th>
                      <th className='table-cell'>Total Disk/Used Disk</th>
                      <th className='table-cell'>Available RAM</th>

                      <th className='table-cell'>Total RAM/Used RAM</th>
                      <th className='table-cell'>CPU %</th>
                      <th className='table-cell'>Historic</th>


                    </tr>
                  </thead>}
                  {Type === 'CloudGlobal' && <thead>

                    <tr className="table-header-light bg-marino">
                      <th className='table-cell'>CTX Name</th>
                      <th className='table-cell'>Available Disk</th>
                      <th className='table-cell'>Total Disk/Used Disk</th>
                      <th className='table-cell'>Available RAM</th>

                      <th className='table-cell'>Total RAM/Used RAM</th>
                      <th className='table-cell'>CPU %</th>
                      <th className='table-cell'>Historic</th>


                    </tr>
                  </thead>}
                  {/* end::Table head */}


                  {/* begin::Table body */}
                  {Type !== 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) =>
                          d.displayName.includes(Type) && (
                            <tr key={i} className='table-row'>
                              {d.displayName !== null ? <td className='table-cell'>{d.displayName}</td> : <td className='table-cell'>---</td>}
                              {d.diskAvailable !== null ? <td className='table-cell'>{d.diskAvailable.toFixed(3)} GB</td> : <td className='table-cell'>---</td>}
                              {d.dskTotal !== null && d.dskUsed !== null ? (
                                <td className='table-cell'>{d.dskTotal.toFixed(3)} GB / {d.dskUsed.toFixed(3)} GB</td>
                              ) : (
                                <td className='table-cell'>---</td>
                              )}
                              {d.ramAvailable !== null ? <td className='table-cell'>{d.ramAvailable.toFixed(3)} GB</td> : <td className='table-cell'>---</td>}
                              {d.ramTotal !== null && d.ramUsed !== null ? (
                                <td className='table-cell'>{d.ramTotal.toFixed(3)} GB / {d.ramUsed.toFixed(3)} GB</td>
                              ) : (
                                <td className='table-cell'>---</td>
                              )}
                              {d.CPUload1m !== null ? <td className='table-cell'>{d.CPUload1m.toFixed(2)}%</td> : <td className='table-cell'>---</td>}

                              <td className='table-cell'>
                                <button
                                  className="btn-relieve f-parrafo"
                                  onClick={() => (setIDPer(null), setchartIdper(i), setCategoryper(categoriesArrays[i]), setdataperformance(dataArrays[i]), setNamectxper(d.displayName))}
                                >
                                  <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '20px' }} />
                                </button>
                              </td>
                              <td></td>
                            </tr>
                          )
                        )
                      )}
                    </tbody>
                  )}
                  {Type === 'CloudGlobal' && (
                    <tbody>
                      {datamonitoring.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', color: 'gray', padding: '20px' }}>
                            No Data Available
                          </td>
                        </tr>
                      ) : (
                        datamonitoring.map((d: any, i: any) => (
                          <tr key={i} className='table-row'>
                            {d.displayName !== null ? <td className='table-cell'>{d.displayName}</td> : <td className='table-cell'>---</td>}
                            {d.diskAvailable !== null ? <td className='table-cell'>{d.diskAvailable.toFixed(3)}</td> : <td className='table-cell'>---</td>}
                            {d.dskTotal !== null && d.dskUsed !== null ? <td className='table-cell'>{d.dskTotal.toFixed(3)}/{d.dskUsed.toFixed(3)}</td> : <td className='table-cell'>---</td>}
                            {d.ramAvailable !== null ? <td className='table-cell'>{d.ramAvailable.toFixed(3)}</td> : <td className='table-cell'>---</td>}
                            {d.ramTotal !== null && d.ramUsed !== null ? <td className='table-cell'>{d.ramTotal.toFixed(3)} / {d.ramUsed.toFixed(3)}</td> : <td className='table-cell'>---</td>}
                            {d.CPUload1m !== null ? <td className='table-cell'>{d.CPUload1m.toFixed(2)}%</td> : <td className='table-cell'>---</td>}

                            <td className='table-cell'>
                              <button className="btn-relieve f-parrafo" onClick={() => (setIDPer(null), setchartIdper(i), setCategoryper(categoriesArrays[i]), setdataperformance(dataArrays[i]), setNamectxper(d.displayName))}>
                                <img src="/media/iconos_v2/external.svg" alt="external" style={{ width: '20px' }} />
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  )}
                  {/* end::Table body */}

                </table>
                {/* end::Table */}
              </div>


            </div>
            {/* end::Tap pane */}
          </div>
        </div>
        <br />

      </div>

      {IDPer !== undefined && <ViewGraficaPerformance setID={setIDPer} id={IDPer} chartId={chartIdper} categorye={Categoryper} data={dataperformance} name={Namectxper} />}

    </>

  );

}

export default LatencyTablePerfor